import React, { useEffect, useRef, useState } from 'react';
import type { ProjectCategory } from '../../../types';

type Props = {
  categories: ProjectCategory[],
  selectedIds: Array<number>,
  onChange: (event: { target: { checked: boolean, value: number } }) => void
};

function CategoryDropdown({ categories, selectedIds, onChange }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedCategories = categories.filter(cat => selectedIds.includes(cat.id),
  );

  const getAvailableCategories = () => {
    let available = categories.filter(cat => !selectedIds.includes(cat.id));
    if (search.trim()) {
      available = available.filter(cat => cat.name.toLowerCase().includes(search.toLowerCase()),
      );
    }

    return available;
  };

  return (
    <div className="space-y-2" ref={dropdownRef}>
      <div className="flex flex-wrap gap-2 mb-2">
        {selectedCategories.map(category => (
          <div
            className="selected-category"
            style={{ ['--category-color' as any]: category.color } as React.CSSProperties}
            key={category.id}
            onClick={() => {
              onChange({
                target: { checked: false, value: category.id },
              });
            }}
          >
            <span className="selected-category-text">
              {category.name}
            </span>
            <div className="selected-category-remove">
              <span style={{ fontSize: '16px', color: 'white' }}>✕</span>
            </div>
          </div>
        ))}
      </div>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search categories..."
          value={search}
          onChange={e => {
            setSearch(e.target.value);
            setIsOpen(true);
          }}
          onFocus={() => setIsOpen(true)}
        />

        {isOpen && (
          <div className="dropdown-content">
            {getAvailableCategories().map(category => (
              <div
                key={category.id}
                style={{
                  marginBottom: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center',
                }}
                onClick={() => {
                  onChange({
                    target: { checked: !selectedIds.includes(category.id), value: category.id },
                  });
                  setSearch('');
                }}
              >
                <span
                  className="color-circle"
                  style={{ ['--category-color' as any]: category.color } as React.CSSProperties}
                />
                <span style={{ verticalAlign: 'middle' }}>{category.name}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default CategoryDropdown;
